import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
// import { Link } from 'react-router-dom';
// import { Path } from '../../constants/path';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      maxWidth: 600,
      margin: '40px auto',
      padding: 20,
      boxSizing: 'border-box'
    },
    managementContainer: {
      backgroundColor: '#ECEFF1',
      padding: 20,
      boxSizing: 'border-box',
      '& p': {
        fontSize: 15,
        color: 'var(--color-gray-1)',
        lineHeight: '22px',
        margin: 0
      }
    },
    managementHeading: {
      color: '#828282 !important',
      fontWeight: 'bold',
      marginBottom: '8px !important'
    },
    body: {
      fontSize: 14,
      color: 'var(--color-text)',
      lineHeight: '21px'
    }
  })
);
const Tokushoho: React.FC = () => {
  const styles = useStyles({});
  return (
    <div className={styles.container}>
      <h1>特定商取引法に基づく表記</h1>
      <p className={styles.body}>
        ■会社名
        <br />
        株式会社CDエナジーダイレクト
        <br />
        <br />
        ■代表者
        <br />
        代表取締役社長 八木 貴央
        <br />
        <br />
        ■所在地
        <br />
        東京都中央区日本橋室町４－５－１　さくら室町ビル
        <br />
        <br />
        ■電話番号
        <br />
        ０１２０-８１１-７９２
        <br />
        <br />
        ■Eメールアドレス
        <br />
        auto-reply@mail.cdesumamoru.entryservice.jp
        <br />
        <br />
        ■商品・役務の提供時期
        <br />
        ・電気：あらたに電気の使用を開始される場合の供給開始予定日は、お客さまが希望される日を基準として、協議することといたします。供給開始後、ご契約内容を記載した書面をお送りいたします。
        <br />
        ・ガス：あらたにガスの使用を開始される場合の供給開始予定日は、お客さまが希望される日を基準として、協議することといたします。供給開始後、ご契約内容を記載した書面をお送りいたします。
        <br />
        ・優待・割引サービス…電気の供給開始日より、提供いたします。
        <br />
        <br />
        ■お申込み有効期限
        <br />
        ・電気：お客さまがサービスの提供を受けることを希望する日の前日まで
        <br />
        ・ガス：お客さまがサービスの提供を受けることを希望する日の５営業日前まで
        <br />
        <br />
        ■商品・役務の対価、対価の支払時期及び方法、提供条件
        <br />
        ・電気の供給における電気の料金その他の供給条件は、電気基本要綱および個別要綱によります。詳細は
        <a href={'/static/cde_base_electric_term.pdf'} target="_blank" rel="noopener noreferrer">
          電気基本契約要綱
        </a>
        をご覧ください。
        <br />
        <br />
        ・ガスの供給におけるガスの料金その他の供給条件は、ガス基本要綱および個別要綱によります。詳細は
        <a href={'/static/cde_base_gas_term.pdf'} target="_blank" rel="noopener noreferrer">
          ガス基本契約要綱
        </a>
        をご覧ください。
        <br />
        <br />
        ・優待・割引サービスの料金の利用条件は、各利用規約によります。詳細は
        <a href={'/static/benefit_one_term.pdf'} target="_blank" rel="noopener noreferrer">
          優待・割引サービス利用規約
        </a>
        をご覧ください。
        <br />
        <br />
        <br />
        ■その他の商品の販売条件、役務の提供条件
        <br />
        ・電気（スマモル賃貸プランに限ります。）および優待・割引サービスは、当社が指定する、物件の管理等を行う事業者からの紹介があり、当社が適当と判断した場合にのみご利用いただけます。
        <br />
        <br />
      </p>
      <p className={styles.body}>
        ■会社名
        <br />
        大阪ガスセキュリティサービス株式会社
        <br />
        <br />
        ■代表者
        <br />
        代表取締役社長 　米田 吉克
        <br />
        <br />
        ■所在地
        <br />
        大阪市淀川区十三本町３−６−５
        <br />
        <br />
        ■電話番号
        <br />
        ０１２０-７５０−０８２
        <br />
        <br />
        ■Eメールアドレス
        <br />
        auto-reply@mail.cdesumamoru.entryservice.jp
        <br />
        <br />
        ■商品・役務の提供時期
        <br />
        ・駆けつけサービス…電気の供給開始日より、提供いたします。
        <br />
        <br />
        ■お申込み有効期限
        <br />
        ・電気の申込有効期限に準じます
        <br />
        <br />
        ■商品・役務の対価、対価の支払時期及び方法、提供条件
        <br />
        ・駆けつけサービスの利用条件は、駆けつけサービス契約約款によります。詳細は
        <a href={'/static/seurity_service_term.pdf'} target="_blank" rel="noopener noreferrer">
          駆けつけサービス契約約款
        </a>
        をご覧ください。
        <br />
        <br />
        <br />
        ■その他の商品の販売条件、役務の提供条件
        <br />
        ・駆けつけサービスは、当社が指定する、物件の管理等を行う事業者からの紹介があり、当社が適当と判断した場合にのみご利用いただけます。
        <br />
        <br />
      </p>
    </div>
  );
};

export default Tokushoho;
